import store from '@/store'
import Vue from 'vue'
const vm = new Vue()
import md5 from 'md5'
import {
  createOrder,
  getOrderStatus,
  createPromotion
} from '@/apis/pay.js'
import {
  regFenToYuan
} from '../utils/index'
// import {
//   routerDict
// } from '@/common/dictionary/index.js'

/**
 * 请求支付
 * order_obj:{
 * temp_index 充值弹窗金币列表索引
 * temp_obj 充值弹窗请求到的特性
 * rechargeType 充值类型
 * }
 * pay_type 支付类型： 1.'coins'-金币 2.'vip'-会员 3.'countDown'-限时优惠(金币)
 * vip_scene 埋点（vip开通）中触发入口：1.充值浮层 2.我的页 3.自定义弹窗
 * pay_from 埋点（充值-充值结果）中触发场景: 1.剧集解锁触发、2非剧集触发、3.福利中心充值任务触发、4.充值促销弹窗触发 5.自定义弹窗触发
 */
export async function requestPayment(order_obj, pay_type = 'coins', vip_scene = '充值浮层', pay_from = '非剧集触发') {
  // store.commit('abPop/SET_PAYPARAMS', {
  //   order_obj,
  //   pay_type,
  //   vip_scene,
  //   pay_from
  // })

  // // 创建订单状态
  return new Promise((resolve, reject) => {
      store.commit('abPop/SET_PAYPARAMS', {
        order_obj,
        pay_type,
        vip_scene,
        pay_from
      })

      // 创建订单状态
      console.log('[createOrder-模板md5]', JSON.stringify(order_obj.temp_obj))
      createOrder({
        template_type: pay_type,
        template_index: order_obj.temp_index || 0,
        template_md5: md5(JSON.stringify(order_obj.temp_obj))
      }).then(res => {
        console.log('订单返回', res)
        REPORT_SDK.report({
          event_name: '订单创建',
          event_id: 'order_creation',
          page_type: pay_type == 'vip' ? '充会员' : '充金币',
          pay_amount: regFenToYuan(res.money),
          page_url: store.state.common.currentPage == '播放-播放首页' ? String(store.state.common.currentVideoId) : ''
        })
        const payObj = {
          timestamp: res.timeStamp,
          nonceStr: res.nonceStr,
          package: res.package,
          signType: res.signType,
          paySign: res.paySign,
        }
        console.log(payObj)
        var reportInfo = {
          order_code: res.order_code,
          pay_result: '成功',
          pay_type,
          pay_money: res.money,
          coins: res.coin
        }
        vm.$wx.chooseWXPay({
          ...payObj,
          success: function (payRes) {
            console.log('success-', payRes)
            reportPay(reportInfo)
            resolve(payRes)
          },
          fail: function (payErr) {
            console.log('fail-', payErr)
            reportInfo.pay_result = '失败'
            reportPay(reportInfo)
            reject(payErr)
          },
          complete: function (res) {
            console.log('complete', res)
          },
          error: function (err) {
            console.log("支付失败", err);
            reportInfo.pay_result = '失败'
            reportPay(reportInfo)
            reject(err)
          },
          cancel: function (err) {
            console.log("支付取消", err);
            reportInfo.pay_result = '失败'
            reportPay(reportInfo)
            reject(err)
          },
        })
      })
    })
    .catch((error) => {
      console.log('[createOrder]-err', error)
      reject(error)
    })
}
async function reportPay(reportInfo) {
  let {
    order_code,
    pay_result,
    pay_type,
    pay_money,
    coins
  } = reportInfo
  // if (pay_result == '成功') {
  //   console.log('[reportPay]-[getUtmSourceAgain]-1')
  //   await store.dispatch('common/getUtmSourceAgain')
  //   console.log('[reportPay]-[getUtmSourceAgain]-2')
  // }
  // // 判断用户属性是曾经是否付费用户，如果是，不做处理，如果否，更新用户信息，并重置AB请求头、特性
  // if (pay_result == '成功' && !store.state.user.userInfo.has_pay) {
  //   AB_SDK.re_set_header('Pay-User', 1)
  //   store.commit('features/RESET_FEATURE_STATE')
  //   store.commit('abPop/SET_POPCLOSEPRECACHEOBJ', null)
  // }
  if (pay_result == '成功') {
    REPORT_SDK.report({
      event_id: 'vcurrency_acquisition',
      event_name: '金币获取',
      page_type: '用户充值',
      scene: String(coins)
    })
  }
  let pay_num = -1
  try {
    const data = await getOrderStatus({
      order_code
    })
    console.error('[requestPayment]-setUserInfo', data)
    pay_num = data.pay_num
    await store.dispatch('user/setUserInfo')
  } catch (err) {
    await store.dispatch('user/setUserInfo')
    console.error('requestPayment__充值结果查询失败:', err)
  }
  let requestTime = new Date().getTime() - store.state.common.appStartTime
  REPORT_SDK.report({
    event_name: '订单支付',
    event_id: 'order_payment',
    page_type: pay_type == 'vip' ? '充会员' : '充金币',
    pay_amount: regFenToYuan(pay_money),
    page_url: store.state.common.currentPage == '播放-播放首页' ? String(store.state.common.currentVideoId) : '',
    result: pay_result,
    page_name: String(pay_num),
    ext_field_1: String(requestTime) || '0'
  })
}
